import styled, { createGlobalStyle } from 'styled-components';

export const SensorFormContainer = styled.div`
  display: flex;
  flex-direction: column;

  .sensor-form-footer {
    display: flex;
    justify-content: flex-end;
  }
`;

export const DeviceTypeSelectGlobalStyle = createGlobalStyle`
  .device-type-select {
    .device-type-label {
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.marginXXS}px;
      
      .icon {
        color: ${({ theme: { token } }) => token.colorIcon};
      }
    }
  }
`;
